import type { FC } from 'react';

import { CalendarInput, TextInput, Typography, formatDate } from 'enable-ui';

import { CustomCalendarInput } from '../styles/calendar';
import { Schedule } from '../styles/lesson';

import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate.svg';
import { ReactComponent as ExternalIcon } from 'assets/icons/external-link.svg';

import type { EventCalendar } from '../core/type';

export const LessonInfoComp: FC<{
  goToDetailPage: () => void;
  handleDuplicate: () => void;
  handleDelete: () => void;
  value: EventCalendar;
  handleChangeValue: (value: Date, startTime: string, endTime: string) => void;
}> = ({ goToDetailPage, handleDuplicate, handleDelete, value, handleChangeValue }) => {
  const startDate = (value?.start ? new Date(value.start) : '') as Date;

  const endDate = (value?.end ? new Date(value.end) : '') as Date;

  const startTime = formatDate(startDate, 'HH:mm');

  const endTime = formatDate(endDate, 'HH:mm');

  return (
    <div style={{ padding: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12 }}>
        <ExternalIcon onClick={goToDetailPage} style={{ cursor: 'pointer' }} />
        <DuplicateIcon onClick={handleDuplicate} style={{ cursor: 'pointer' }} />
        <DeleteIcon onClick={handleDelete} style={{ cursor: 'pointer' }} />
      </div>
      <Typography variant="h3" weight={700}>
        {value?.title}
      </Typography>
      <Typography>{value?.type}</Typography>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 24 }}>
        <CustomCalendarInput>
          <CalendarInput
            date={startDate}
            containerStyle={{ width: '40%' }}
            onChange={(newValue) => handleChangeValue(newValue, startTime, endTime)}
          />
        </CustomCalendarInput>

        <Schedule>
          <TextInput
            type="time"
            containerStyle={{ maxWidth: 'auto', width: '50%' }}
            onChange={(e) => handleChangeValue(startDate, e.target.value, endTime)}
            value={startTime}
            disabled={!startDate}
          />
          <span>-</span>
          <TextInput
            type="time"
            containerStyle={{ maxWidth: 'auto', width: '50%' }}
            onChange={(e) => handleChangeValue(startDate, startTime, e.target.value)}
            value={endTime}
            disabled={!startDate}
          />
        </Schedule>
      </div>
    </div>
  );
};
